import { OccupancyRatesDetailDto } from '@client/api';
import i18n from 'i18next';

export const transformToExcelFormat = (
  data: OccupancyRatesDetailDto[],
  baseYear: number,
  selectedRows: Set<string>,
) => {
  const rows: Record<string, any>[] = [];
  if (data.length === 0) return [{ [i18n.t('noData', { ns: 'reporting' })]: null }];

  const t = (key: string, opts?: Record<string, any>) => i18n.t(key, { ns: 'reporting', ...opts });
  const tType = (key: string) => i18n.t(key, { ns: 'type' });

  data.forEach((building) => {
    if (selectedRows.has(building.id) || selectedRows.size === 0) {
      // Building summary row
      rows.push({
        [t('occupancyRateRow.building')]: building.name,
        [t('occupancyRateRow.totalArea')]: `${building.totalM2 ?? 0} m² / ${building.totalSpaceCount ?? 0}`,
        [t('occupancyRateRow.rentedArea')]: `${building.rentedM2 ?? 0} m² / ${building.rentedSpaceCount ?? 0}`,
        [t('occupancyRateRow.vacantArea')]: `${building.vacantM2 ?? 0} m² / ${building.vacantSpaceCount ?? 0}`,
        [t('occupancyRateRow.occupancyRate', { year: baseYear })]: building.occupancyRate,
        [t('occupancyRateRow.occupancyRate', { year: baseYear - 1 })]: building.previousYearOccupancyRate,
        [t('occupancyRateRow.occupancyChangePercentage')]: building.occupancyChangePercentage,
      });

      // Space detail rows (flat, sorted Ledig first)
      const sortedChildren = [...(building.children ?? [])].sort((a, b) => {
        const order: Record<string, number> = { Vacant: 0, VacantSoon: 1, Rented: 2 };
        return (order[a.vacancyStatus ?? ''] ?? 3) - (order[b.vacancyStatus ?? ''] ?? 3);
      });

      sortedChildren.forEach((space) => {
        rows.push({
          [t('occupancyRateRow.building')]: null,
          [t('occupancyRateRow.areaName')]: space.name,
          [t('occupancyRateRow.location')]: space.parentName ?? '-',
          [t('occupancyRateRow.assetClass')]: space.assetClass ? tType(`AssetClass.${space.assetClass}`) : '-',
          [t('occupancyRateRow.areaM2')]: space.m2 != null ? `${space.m2} m²` : '-',
          [t('occupancyRateRow.tenant')]: space.tenantName ?? '-',
          [t('occupancyRateRow.leaseStart')]: space.startDate ?? '-',
          [t('occupancyRateRow.leaseEnd')]: space.endDate ?? '-',
          [t('occupancyRateRow.status')]: space.vacancyStatus ? tType(`VacancyStatus.${space.vacancyStatus}`) : '-',
        });
      });
    }
  });
  return rows;
};
